module.exports = __webpack_public_path__ + "static/media/article-test.eadb7ed0.jpg";